import { Synchronized } from '#common/util';
import { parseWasmResult } from '#wasm/common';
export class ConfigWasm extends Synchronized {
    modSync;
    modAsync;
    constructor(modSync, modAsync, mutex) {
        super(mutex);
        this.modSync = modSync;
        this.modAsync = modAsync;
    }
    createSetting(settingFullName, value) {
        const result = parseWasmResult(this.modSync.CreateSetting(settingFullName.target, settingFullName.name, value));
        result.name = settingFullName;
        return result;
    }
    createMultiStringSetting(settingFullName, values) {
        const result = parseWasmResult(this.modSync.CreateMultiStringSetting(settingFullName.target, settingFullName.name, values));
        result.name = settingFullName;
        return result;
    }
    getSettingDetails(settingFullName) {
        return parseWasmResult(this.modSync.GetSettingDetails(settingFullName.target, settingFullName.name));
    }
    async getEncryptedSettings(settingNames) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.modAsync.GetEncryptedSettings(settingNames));
        });
    }
    async unsetSettings(settingNames) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.modAsync.UnsetSettings(settingNames));
        });
    }
    rawSettingValueToString(value) {
        return parseWasmResult(this.modSync.RawSettingValueToString(value));
    }
}
